module.exports = __webpack_public_path__ + "static/media/img_step_5.3fdece26.jpg";